import { render, staticRenderFns } from "./Profesionales.vue?vue&type=template&id=4ab2c7ea&scoped=true&"
import script from "./Profesionales.vue?vue&type=script&lang=js&"
export * from "./Profesionales.vue?vue&type=script&lang=js&"
import style0 from "./Profesionales.vue?vue&type=style&index=0&id=4ab2c7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2c7ea",
  null
  
)

export default component.exports